import React, { memo, useContext, useEffect, useState } from "react";
import { Camera, CameraZone } from "~/schemas/generated/graphql";
import Preloader from "~/components/Preloader";
import s from "../CameraZonesView.less";
import { get } from "lodash";
import Pagination from "~/components/Pagination";
import { CamerasContext } from "~/pages/CameraZonesView";
import { CAMERA_VIEW_OPTIONS } from "~/pages/CameraZonesView/utils/options";
import { getFormatDate } from "~/libs/getFormatDate";
import { TableV2 } from "~/shared/ui/TableV2";
import { getCameraColumns } from "~/pages/CameraZonesView/model/tableAdapter";
import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

type TParams = {
  page: string;
  count: string;
};

interface IZoneViewPartProps {
  currentZone: CameraZone;
}

const ZoneViewPart = ({ currentZone }: IZoneViewPartProps) => {
  const history = useHistory();
  const { t } = useTranslation();
  const setURLParams = useURLParamsSetter();
  const [cameraList, setCameraList] = useState<Camera[]>([]);
  const [cameraListTotal, setCameraListTotal] = useState(0);
  const {
    fetchCameras,
    getCameraListState,
    dealerInfo,
    dealerInfoLoading,
    userCanAddCamera,
  } = useContext(CamerasContext);

  const handleOpenViewModal = ({ id }: Camera) =>
    setURLParams({ openModal: "ViewCamera", cameraId: id });

  const handleEdit = (record: any) =>
    setURLParams({ openModal: "Edit", currentId: record.id });

  const handleDelete = (record: any) =>
    setURLParams({ openModal: "Sure", currentId: record.id });

  useEffect(() => {
    if (currentZone && dealerInfo) fetchCameras();
  }, [currentZone, dealerInfoLoading]);

  useEffect(() => {
    if (getCameraListState.data && !getCameraListState.loading) {
      setCameraList(
        get(getCameraListState.data, "CameraGetter.getCameras.items", [])
      );
      setCameraListTotal(
        get(getCameraListState.data, "CameraGetter.getCameras.total", 0)
      );
    }
  }, [getCameraListState]);

  useEffect(() => {
    if (
      getCameraListState.called &&
      !getCameraListState.loading &&
      !(get(getCameraListState.data, "CameraGetter.getCameras.items", []) as [])
        .length
    ) {
      history.push(`/camera-view/`);
    }
  }, [getCameraListState]);

  if (!cameraList.length)
    return (
      <div className={s.preloaderWrapper}>
        <Preloader />
      </div>
    );

  return (
    <Pagination total={cameraListTotal}>
      {/*
      <Table
        options={CAMERA_VIEW_OPTIONS}
        items={cameraList}
        sortable={false}
        loading={getCameraListState.loading}
        type={"cameraView.table"}
        rowValuesDecorator={tableValueDecorator}
        rowClickHandler={handleOpenViewModal}
        rowCanBeClicked
        btnEdit={userCanAddCamera}
        btnDel={userCanAddCamera}
      />
      */}
      {/*<div className={`${s.greedWrapper} ${s.marginTop}`}>*/}
      {/*  {cameraList.map(({ id, name, status }) => (*/}
      {/*    <CamItem key={id} id={id} cameraName={name} status={status} />*/}
      {/*  ))}*/}
      {/*</div>*/}
      <TableV2
        columns={getCameraColumns(t)}
        dataSource={cameraList}
        loading={getCameraListState.loading}
        rowKey="id"
        scroll={{ x: "max-content" }}
        onRow={(record) => ({
          onClick: () => handleOpenViewModal(record as Camera),
        })}
        {...(userCanAddCamera && {
          onRowEdit: handleEdit,
          onRowDelete: handleDelete,
        })}
      />
    </Pagination>
  );
};

export default memo(ZoneViewPart);
